import { WindowToken } from '../../injection-tokens';
import { Container } from 'typedi';
import { LoggerProvider } from '../logger';
import { PlatformLogoutReason, StaticPaths } from '../../models/enums/general-enums';
import { ViewInjector } from '../view-injector';
import { BrandUtils } from '../../../Modules/Utils/BrandUtils';
import { IIdentity } from './models/IIdentity';
import { ILogger } from '@sparkware/uc-sdk-core';
import { LoaderManager } from '../../loaders/LoaderManager';
import { ILogout } from '../logout/models';
import { Router } from '../router/router';

export class Identity implements IIdentity {
    private readonly _window: Window;
    private readonly _logger: ILogger;
    private readonly _router: Router;
    private readonly _viewInjector: ViewInjector;

    private get _logoutPromise(): Promise<ILogout> {
        return LoaderManager.Instance.LogoutLoader.Instance;
    }

    constructor() {
        this._window = Container.get(WindowToken);
        this._logger = Container.get(LoggerProvider).getLogger('Identity');
        this._router = Container.get(Router);
        this._viewInjector = Container.get(ViewInjector);
        this.handlePopStateEvents = this.handlePopStateEvents.bind(this);
    }

    public onLogout = async (): Promise<void> => {
        await this._viewInjector.OnAuthenticationStatusChangeContentUpdate();
    };

    public onLoginSuccess = async (): Promise<void> => {
        await this._viewInjector.OnAuthenticationStatusChangeContentUpdate();
    };

    public async handlePopStateEvents(): Promise<void> {
        if (BrandUtils.isPokerClient()) {
            void this._router.NavigateTo(StaticPaths.PokerRoot);
        } else {
            void this._router.NavigateTo(StaticPaths.Root);
        }
        this._window.removeEventListener('popstate', this.handlePopStateEvents);
        this._window.document.querySelector('.main-loader')?.remove();
    }

    public onUserAuthenticationFailed = async ({ error }): Promise<void> => {
        this._logger.debug('userAuthenticationFailed message received. error: ', error);
        await (await this._logoutPromise)?.doLogout(PlatformLogoutReason.LoginError);
        this._window.addEventListener('popstate', this.handlePopStateEvents);
    };
}
